import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b425ea6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mfa-page"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "recovery codes", -1))
const _hoisted_3 = { class: "secret-container" }
const _hoisted_4 = { class: "secret-container" }

import { computed, onBeforeMount, ref, onMounted } from 'vue'
import { getRecoveryCodes } from '@/api/mfa'
import { faCircleCheck } from 'fontawesome/free-solid-svg-icons'
import store from '@/mobile/src/store'
import Typography from '@/components/Rain/Typography/Typography.vue'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { showToast } from '@/mobile/src/utils/toastbus'
import useEmitter from '@/composables/useEmitter'
import { ToastColor, ToastIcon } from '@/mobile/src/types/toasts'
import { sleep } from '@/utils/async'
import PillButton from '@/components/PillButton.vue'
import { useRoute, useRouter } from 'vue-router'
import { Clipboard } from '@capacitor/clipboard'


export default /*#__PURE__*/_defineComponent({
  __name: 'MFARecoveryCodes',
  setup(__props) {

const loading = ref(false)
const copied = ref(false)
const codes = ref('')
const forcedMFA = ref(false)
const fromMfaSetup = ref(false)
const userHasMfa = computed(() => store.getters['userHasMfa'])

const copyText = computed(() => {
    return copied.value ? 'Copied to Clipboard' : 'Copy to Clipboard'
})

const route = useRoute()
const router = useRouter()
const emitter = useEmitter()

onBeforeMount(async () => {
    forcedMFA.value = route.params.forcedMFA === 'true'
    fromMfaSetup.value = route.params.fromMfaSetup === 'true'
})

onMounted(async () => {
    await getRecoveryCodesResponse()
})

function showFailureToast() {
    showToast(
        emitter,
        ToastIcon.Success,
        ToastColor.InternalNote,
        `All previously generated recovery codes remain valid`,
        4000
    )
}

async function copyToClipboard() {
    const secretToCopy = document.getElementsByClassName(
        'secret-container'
    )[1] as HTMLInputElement

    // copy Link
    await Clipboard.write({
        string: secretToCopy.innerText.trim(),
    })

    copied.value = true
    await sleep(2000)
    copied.value = false
}

async function getRecoveryCodesResponse() {
    loading.value = true
    let recoveryCodes = await getRecoveryCodes()
    if (recoveryCodes) {
        codes.value = recoveryCodes
    } else {
        showFailureToast()
        await sleep(4000)
        await redirectMFA()
    }
    loading.value = false
}

async function redirectMFA() {
    const routerName =
        forcedMFA.value || !fromMfaSetup.value
            ? store.getters.mainNavTabs[0].name
            : 'mfa-reset'
    await router.replace({
        name: routerName,
        replace: true,
    })
    return
}

return (_ctx: any,_cache: any) => {
  return (userHasMfa.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(FontAwesomeIcon), {
          class: "key-icon",
          icon: _unref(faCircleCheck)
        }, null, 8, ["icon"]),
        _createVNode(Typography, {
          variant: "h4",
          component: "h4",
          class: "reset title-container"
        }, {
          default: _withCtx(() => [
            (fromMfaSetup.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("MFA Successfully Setup")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("Your Recovery Codes")
                ], 64))
          ], undefined, true),
          _: 1
        }),
        _createVNode(Typography, {
          variant: "body2",
          class: "detail-container"
        }, {
          default: _withCtx(() => [
            _createTextVNode("If you lose access to your authenticator and need to log back in, below are your "),
            _hoisted_2,
            _createTextVNode(". Please note that each code is one-time use. Copy the codes and keep it in a safe place.")
          ], undefined, true),
          _: 1
        }),
        _withDirectives(_createElementVNode("div", _hoisted_3, "Loading codes...", 512), [
          [_vShow, loading.value]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codes.value, (code) => {
            return (_openBlock(), _createElementBlock("code", { key: code }, _toDisplayString(code), 1))
          }), 128))
        ], 512), [
          [_vShow, codes.value && !loading.value]
        ]),
        _createVNode(PillButton, {
          label: copyText.value,
          disabled: loading.value || copied.value,
          class: "is-v4 btn-space",
          onClick: copyToClipboard
        }, null, 8, ["label", "disabled"]),
        _createVNode(PillButton, {
          label: "done",
          disabled: loading.value,
          class: "is-v4",
          onClick: redirectMFA
        }, null, 8, ["disabled"])
      ]))
    : _createCommentVNode("", true)
}
}

})